import $ from 'jquery';
import common from './common';
import scroll from './scroll';
import {gsap} from "gsap";

const transitions = {
    elClicked: null,
    play: false,
    next: null,
    speedShow: 1,
    delayShow: 0.6,

    basicTransition: {
        leave({current, next}) {
            setTimeout(function(){
                transitions.showNamespace(next);
                //console.log(next.namespace);
            },100);
            return new Promise((resolve) => {
                // Scroll to top before leaving the page
                common.goTOP();

                // Fade out current container with a quicker duration
                gsap.to(current.container, {
                    opacity: 0,
                    duration: 1.5,
                    onComplete: resolve
                });
            });
        },

        enter({next}) {
            // Show namespace before starting transition
            if (scroll.locomotiveScroll) {
                scroll.destroy();
            }
            next.container.style.visibility = 'visible';
            gsap.from(next.container, {
                opacity: 0,
                duration: 0.8, // Show next container in a quicker transition
                onComplete: () => {
                    // Initialize Locomotive Scroll after the page is displayed
                    common.init();
                    scroll.locomotive();
                }
            });
        }
    },

    showNamespace(next) {
        const namespace = next.namespace;
        $(".nav > li[data-m!="+namespace+"]").removeClass("_activ");
        $(".nav > li[data-m="+namespace+"]").addClass("_activ");
    }
};

export default transitions;
